import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { withStyles } from '@mui/styles';
import { createStyles } from '@mui/styles';

import { Labeled } from 'react-admin';

const sanitizeRestProps = ({ basePath, record, ...rest }) => rest;

const styles = theme =>
    createStyles({
        //input: { width: theme.spacing.unit * 32 },
    });

const divStyles = {
    display: 'inline',
    padding: '10px'
};

export const InlineFormInput = ({ classes, input, ...rest }) =>
    input ? (
        <div
            style = {divStyles}
            className={classnames(
                'ra-input',
                `ra-input-${input.props.source}`,
                input.props.formClassName
            )}
        >
            {input.props.addLabel ? (
                <Labeled
                    id={input.props.id || input.props.source}
                    {...input.props}
                    {...sanitizeRestProps(rest)}
                >
                    {React.cloneElement(input, {
                        className: classnames(
                            {
                                [classes.input]: !input.props.fullWidth,
                            },
                            input.props.className
                        ),
                        id: input.props.id || input.props.source,
                        ...rest,
                    })}
                </Labeled>
            ) : (
                React.cloneElement(input, {
                    id: input.props.id || input.props.source,
                    ...rest,
                })
            )}
        </div>
    ) : null;

InlineFormInput.propTypes = {
className: PropTypes.string,
classes: PropTypes.object,
input: PropTypes.object,
};

// wat? TypeScript looses the displayName if we don't set it explicitly
InlineFormInput.displayName = 'InlineFormInput';

export default withStyles(styles)(InlineFormInput);